import { logoutAction } from 'actions/auth';
import { openModal } from 'actions/modal';

import { useAccessOrgs, useMe, useThunkDispatch } from 'utils/reduxHook';
import InAppRoutes from 'utils/router';
import { isUserThryveAdmin } from 'utils/index';

import ApplicationInfo from 'components/atoms/ApplicationInfo';
import UserMenuLink from './UserMenuLink';

function UserMenuItems({ onChangeRoute }: { onChangeRoute?: () => void }) {
  const dispatch = useThunkDispatch();
  const me = useMe();
  const accessOrgs = useAccessOrgs();

  return (
    <div className="relative">
      <div className="px-2 lg:px-4 lg:border-b lg:border-charcoal-700">
        {accessOrgs.length > 0 && (
          <div
            onClick={() => {
              dispatch(openModal('SwitchOrganizations'));
              if (onChangeRoute) {
                onChangeRoute();
              }
            }}
            className="cursor-pointer py-2 text-charcoal-400 text-sm font-normal focus:outline-none md:hover:text-charcoal-50"
            data-durable-id="navSwitchAccount"
          >
            Switch Accounts
          </div>
        )}
      </div>
      <div className="px-2 lg:px-4 lg:border-b lg:border-charcoal-700">
        <div
          onClick={() => {
            dispatch(logoutAction());
            if (onChangeRoute) {
              onChangeRoute();
            }
          }}
          className="cursor-pointer py-2 text-charcoal-400 text-sm font-normal focus:outline-none md:hover:text-charcoal-50"
          data-durable-id="navUserSignOut"
        >
          Sign out
        </div>
      </div>

      {isUserThryveAdmin(me) && (
        <div className="px-2 lg:px-4">
          <div className="text-charcoal-900 lg:text-white pt-2 text-sm font-semibold">Super Admin</div>
          <UserMenuLink
            to={InAppRoutes.AdminAuthoringHome}
            title="Authoring"
            italic
            dataDurableId="navSuperAdminAuthoring"
          />
          <UserMenuLink
            to={InAppRoutes.AdminConversationPrompts}
            title="Conversation Prompts"
            italic
            data-dd-privacy="allow"
          />
        </div>
      )}
      <ApplicationInfo />
    </div>
  );
}

export default UserMenuItems;
